export function parseDateValue(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

function startOfDay(value) {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
}

function startOfWeekSunday(value) {
  const date = startOfDay(value);
  date.setDate(date.getDate() - date.getDay());
  return date;
}

export function getWeeklyOccurrenceInWeekStarting(lesson, weekStart) {
  const anchor = parseDateValue(lesson?.scheduled_at);
  if (!anchor) return null;

  const targetDow = anchor.getDay();
  const targetHours = anchor.getHours();
  const targetMinutes = anchor.getMinutes();
  const targetSeconds = anchor.getSeconds();
  const targetMs = anchor.getMilliseconds();

  const start = startOfDay(weekStart);
  const candidate = new Date(start);

  const delta = (targetDow - candidate.getDay() + 7) % 7;
  candidate.setDate(candidate.getDate() + delta);
  candidate.setHours(targetHours, targetMinutes, targetSeconds, targetMs);

  if (candidate.getTime() < anchor.getTime()) return null;
  return candidate;
}

export function getRelevantWeeklyOccurrenceStart(lesson, referenceDate = new Date()) {
  const anchor = parseDateValue(lesson?.scheduled_at);
  if (!anchor) return null;

  const ref = parseDateValue(referenceDate) || new Date();
  if (ref.getTime() < anchor.getTime()) return anchor;

  const weekStart = startOfWeekSunday(ref);
  const occurrence = getWeeklyOccurrenceInWeekStarting(lesson, weekStart) || anchor;

  const durationMinutes = Number(lesson?.duration_minutes) || 60;
  const endTs = occurrence.getTime() + durationMinutes * 60 * 1000;
  if (ref.getTime() <= endTs) {
    return occurrence;
  }

  const next = new Date(occurrence);
  next.setDate(next.getDate() + 7);
  return next;
}

export function getLessonRelevantStart(lesson, referenceDate = new Date()) {
  if (!lesson?.scheduled_at) return null;
  if (lesson.is_recurring_weekly) {
    return getRelevantWeeklyOccurrenceStart(lesson, referenceDate);
  }
  return parseDateValue(lesson.scheduled_at);
}

export function getLessonRelevantStartTs(lesson, referenceDate = new Date()) {
  const start = getLessonRelevantStart(lesson, referenceDate);
  if (!start) return null;
  return start.getTime();
}

export function materializeLessonForReference(lesson, referenceDate = new Date()) {
  if (!lesson?.scheduled_at) return null;
  if (!lesson.is_recurring_weekly) return lesson;

  const occurrenceStart = getRelevantWeeklyOccurrenceStart(lesson, referenceDate);
  if (!occurrenceStart) return null;

  return {
    ...lesson,
    scheduled_at: occurrenceStart.toISOString(),
    __base_scheduled_at: lesson.scheduled_at,
    __occurrence_scheduled_at: occurrenceStart.toISOString(),
  };
}
